import { ExchangeGroup } from "@redotech/redo-model/team";
import { createContext, useState } from "react";

const ExchangeTypeContext = createContext<{
  exchangeType: string | undefined;
  setExchangeType: (exchangeType: string) => void;
  exchangeGroup: ExchangeGroup | undefined;
  setExchangeGroup: (selectedExchangeGroup: ExchangeGroup) => void;
}>({
  exchangeType: undefined,
  setExchangeType: (exchangeType: string) => {},
  exchangeGroup: undefined,
  setExchangeGroup: (selectedExchangeGroup: ExchangeGroup) => {},
});

const ExchangeTypeContextProvider = ({ children }) => {
  const [exchangeType, setExchangeType] = useState<string>(undefined);
  const [exchangeGroup, setExchangeGroup] = useState<ExchangeGroup>(undefined);

  return (
    <ExchangeTypeContext.Provider
      value={{
        exchangeType,
        setExchangeType,
        exchangeGroup,
        setExchangeGroup,
      }}
    >
      {children}
    </ExchangeTypeContext.Provider>
  );
};

export { ExchangeTypeContext, ExchangeTypeContextProvider };
